export const reports =`<p><strong>Reporting preferences</strong></p>
<p><strong>Navigation:</strong> Admin / Client report preferences / Select required account / Create preferences</p>
<p>You can only access relevant report information if your role has the relevant permissions.</p>
<p>In order to receive statements, you will need to be set up with the channel that is your preferred delivery method – CBD, SWIFT-FIN OR API.</p>
<p>You may set your reporting preferences for the following types of reports:</p>
<table style="width:100%;border:1px">
<tr style="border:1px solid">
<th style="border:1px solid;padding:5px">Format</th>
<th style="border:1px solid;padding:5px">Display name</th>
<th style="border:1px solid;padding:5px">Description</th>
<th style="border:1px solid;padding:5px">Delivery methods available</th>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">MT940</td>
<td style="border:1px solid;padding:5px">Customer Statement Message</td>
<td style="border:1px solid;padding:5px">Prior Day Account Report</td>
<td style="border:1px solid;padding:5px">CBD, SWIFT-FIN, API</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">MT942</td>
<td style="border:1px solid;padding:5px">Interim Transaction Report</td>
<td style="border:1px solid;padding:5px">Intra Day Account Report</td>
<td style="border:1px solid;padding:5px">CBD, SWIFT-FIN, API</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">MT950</td>
<td style="border:1px solid;padding:5px">Statement Message</td>
<td style="border:1px solid;padding:5px">Prior Day Account Report</td>
<td style="border:1px solid;padding:5px">SWIFT-FIN, API</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">Camt.053 Detailed</td>
<td style="border:1px solid;padding:5px">Bank to Customer Statement Detail</td>
<td style="border:1px solid;padding:5px">Prior Day Account Report</td>
<td style="border:1px solid;padding:5px">CBD, API</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">Camt.053 Summary</td>
<td style="border:1px solid;padding:5px">Bank to Customer Statement Summary</td>
<td style="border:1px solid;padding:5px">Prior Day Account Report</td>
<td style="border:1px solid;padding:5px">CBD, API</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">Camt.052</td>
<td style="border:1px solid;padding:5px">Bank to Customer Account Report</td>
<td style="border:1px solid;padding:5px">Intra Day Account Report</td>
<td style="border:1px solid;padding:5px">CBD, API</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">LS01</td>
<td style="border:1px solid;padding:5px">Legal Bank Statement</td>
<td style="border:1px solid;padding:5px">Legal Bank Statement</td>
<td style="border:1px solid;padding:5px">GEM - Access via Reports / Reporting and Statements/ Download Legal Bank Statement</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">MT900</td>
<td style="border:1px solid;padding:5px">Confirmation of Debit</td>
<td style="border:1px solid;padding:5px">Debit/Credit Notification</td>
<td style="border:1px solid;padding:5px">CBD, SWIFT-FIN</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">MT910</td>
<td style="border:1px solid;padding:5px">Confirmation of Credit</td>
<td style="border:1px solid;padding:5px">Debit/Credit Notification</td>
<td style="border:1px solid;padding:5px">CBD, SWIFT-FIN</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">Camt.054</td>
<td style="border:1px solid;padding:5px">Bank to Customer Debit / Credit Notification</td>
<td style="border:1px solid;padding:5px">Debit/Credit Notification</td>
<td style="border:1px solid;padding:5px">CBD</td>
</tr>
<tr style="border:1px solid">
<td style="border:1px solid;padding:5px">BAI2</td>
<td style="border:1px solid;padding:5px">Cash management balance report</td>
<td style="border:1px solid;padding:5px">Prior Day Account Report</td>
<td style="border:1px solid;padding:5px">CBD, API</td>
</tr>
</table>
</p>`

export const informationReports =`<p>&nbsp;<strong>Navigation</strong>: Reports / Reporting and Statements/ Information Reports&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/1/info_reports.png'/></p>
<p>&nbsp;<strong>Overview</strong>
<p>Lloyds Bank Gem Connect offers you a suite of reports to manage and monitor activity across your accounts. You can use filters and date ranges to produce reports for the specific data you require.</p>
<p>The Balance summary and detail report and the Transaction details report provide account balances and transaction details.</p>
<p>The Account management status report provides a summary of all changes made to your accounts and whether they were approved or rejected (and if so, the reason why).</p>
<p>The inter-company lending report gives details of sweeping transactions between different legal entities.</p>
<p>You have the ability to create one off reports, or you can save report criteria so the report can be re-run easily, without setting up the details every time you want the information.  You may also edit these saved reports though only the user who has created the report is entitled to do so.</p>

<p><strong>Step 1:</strong> </p>
<p>To create a new report, click on the name of the report displayed under the heading “Create new report”. For example, click on “Balance summary and detail” and you will be displayed the parameters you can select to create the report.</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/1/1.png'/></p>

<p><strong>Step 2:</strong> </p>
<p>Select the relevant parameters within the report.</p>
<p>If you wish to save the report parameters for future use, select “Save report criteria”.</p>   
<p>Click on  “Generate Report” to run the report.</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/1/2.png'/></p>
<p><strong>Parameters for Transaction detail and Balance summary and detail reports</strong> </p>
<p><strong> Account: </strong>the maximum number of accounts you can select varies, depending on the Delivery method and Format you choose.</p>
<ul style='list-style-type:disc'>
<li>There is a configured limit for the number of accounts you can select when:</li>
<ul class='list-style-circle'>
 <li>Delivery method = Display online</li>
 <li>Delivery method = Export and Format = HTML, Tab delimited, PDF or Plain text.</li>
 </ul>
<li>If you breach this account limit, you will see an error message highlighting the limit and asking you to refine your selection criteria to reduce the number of accounts selected.</li>
<li>A larger number of accounts may be selected when:</li>
<ul class='list-style-circle'>
 <li>Delivery method = Export and Format = CSV data or CSV consolidated. </li>
 </ul>
<li>If you breach this higher CSV export account limit, you will see an error message highlighting this limit and asking you to refine your selection criteria to reduce the number of accounts selected.</li>
 </ul>
<p><strong> Transaction groups: </strong>defaults to All transactions.  Click on the drop down to select other options such as All credit transactions or specific methods of payment.</p>
<p><strong> Date range: </strong>click within the Date range box to select either a relative date range (such as “Last week”) or choose a specific start and end date range. If you choose to Export in CSV data or CSV consolidated format, you may choose a larger date range of up to 12 months.</p>
<p><strong> Payment references: </strong>defaults to no references.  Click on the dropdown to select one or many references to include in your report. Notably, PDF and HTML formats do not include references, even if you select references. </p>
<p><strong> Format: </strong>the Transaction details report includes a format “CSV consolidated” .  This format includes the GEM account in every row,  it has one header only and no line breaks after each different GEM account.  The CSV consolidated format includes additional data items, compared to other formats:  Credit currency,  Bank country, SWIFT BIC and UETR number.</p>
<p><strong> Shared report: </strong>Once you have entered your report criteria, if you tick the Shared report tick box and then click on the “Save report criteria” button, this will save your report and share it with all other entitled users within your legal entity.&nbsp;</p>
<p><strong> Favourite report: </strong>If you tick the Favourite report tick box and click on the “Save report criteria” button, this will ensure the report appears at the top of any relevant report searches you undertake.</p>
<p><strong> Save report criteria: </strong>When you create a report and click on “Save report criteria”, a pop up will be displayed and you can add a name and a description for the report you want to save. The saved report can then be accessed from the Information reporting home screen. The “Load saved report” section of the home screen will display all saved reports in the drop down list. You run the saved report by selecting the report from the drop down and then clicking on “Go”. You can also edit and delete saved reports.</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/1/3.png'/></p>
<p><strong>Reporting larger volumes</strong> </p>
<p>As mentioned above, for Transaction detail and Balance summary and detail reports, if you want to report on a larger volume of accounts and/or transactions and/or up to 12 months of data, please choose to Export in CSV data or CSV consolidated format.</p>
<p>There will still be a limit on the number of accounts and/or transactions that can be returned, but the supported volumes for export in these two CSV formats are greater than exporting in other formats or displaying the report online.</p>
<p>When you Export your report in either of these CSV formats and the applicable transactions are above the limit for one report, you will see the Export Reports Summary screen. On this screen, the associated account and transaction details are split across multiple reports. For example, in the Export Reports Summary screen shot below, the first 20000 transactions are shown in the first split report, the next 20000 transactions are shown in the second split report and so on.</p>
<p>On clicking “Download” against each split report you can Open the report or Save it to your own machine.</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/1/4.png'/></p>
<p><strong><i>Please note if you are looking to extract information for a materially large number of accounts or transactions, the Gem Connect online reporting tool is not the recommended mechanism. Please consult your Onboarding & Servicing contact to discuss our SAP Analytics Cloud reporting capability. 
<p>A link to the guide for SAP Analytics Cloud can be found here:</i><br/>
<a href='${process.env.PUBLIC_URL}/User_Guide_Analytics.pdf' target='_blank'>User Guide-Analytics.pdf</a></p>
</strong></p>`

export const downloadLegalReporting = `<p>&nbsp;&nbsp;</p>
<p><strong>Navigation</strong>: Reports / Reporting and Statements/ Download Legal Bank Statement</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/2/1.png'/></p>
<p><strong>Overview:</strong></p>
<p>On this page you can download a PDF copy of the company’s legal bank statement which will show a summary of opening and closing balances within the specified date range. You can do this for single or multiple accounts or Account Group(s).</p>
<p>Use the options on the left of the page to search for relevant accounts or Account Groups. For more options, click <strong>Advanced search</strong>.&nbsp;</p>
<p>Choose an option from the <strong>Category</strong> menu. Then choose a search filter from the <strong>Filter</strong> menu:</p>
<ul>
  <li><strong>Entity</strong>: lists entities that you have permission to view.</li>
  <li><strong>Currency</strong>: lists currencies for the account you want to view. GBP is at the top of the list.</li>
  <li><strong>Account group</strong>: lists your custom account groups. Favourite groups are at the top of the list.</li>
</ul>
<p>Once you have selected the relevant account(s) you are then able to download your Legal Bank statement.</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/2/2.png'/></p>`

export const intradayStatement = `<p><strong>Warning</strong>: If you are looking to export a material volume of payments/ transactions,  request Onboarding & Servicing to set you up with automated MT940/MT942 and set up the <strong>CAMT</strong> 0<strong>.53 Summary</strong> and <strong>CAMT 0.53 Detail</strong> for <strong>End Of Day</strong> and <strong>CAMT 0.52 for Intraday</strong> which can be downloaded as outlined below.&nbsp;</p>
<p><strong>Navigation</strong>: Reports / Reporting and Statements/ Request End of Day or Intraday Statements</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/3/1.png'/></p>
<p><strong>Overview:</strong></p>
<p>On this page you can download <strong>End of day </strong>or <strong>Intraday statements</strong> These statements list your transactions for single or multiple accounts or Account Group(s) in a given timeframe and may not reflect your accurate balances, for this purpose please use the Legal bank statement.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/3/2.png'/></p>
<p><em><strong>You can receive your statements on a daily, weekly or monthly basis as outlined in the table below:&nbsp;</strong></em></p>
<table class='table table-bordered'>
<thead>
<tr>
<td>Frequency</td>
<td>Example</td>
</tr>
</thead>
<tbody>
<tr>
<td>Daily</td>
<td>
<p>Each working day of the week.&nbsp;</p>
<p><strong>Note: </strong>statements won’t be received on bank-holidays and will be supplied on the next working day. &nbsp;</p>
</td>
</tr>
<tr>
<td>Weekly</td>
<td>
<p>Each Friday of the week</p>
<p><strong>Note: </strong>statements won’t be received on bank-holidays and will be supplied on the next working day. &nbsp;</p>
</td>
</tr>
<tr>
<td>Monthly</td>
<td>
<p>The 28th day of each month&nbsp;</p>
<p><strong>Note: </strong>statements won’t be received on bank-holidays or the weekend and will be supplied on the next working day. &nbsp;</p>
</td>
</tr>
</tbody>
</table>
<p><strong>Formats available:</strong></p>
<p>Use the <strong>Format </strong>menu to only show specific statement formats in the table:</p>
<p>End of day statements:</p>
<ul>
  <li>BAI2</li>
  <li>CAMT.053 Detail</li>
  <li>CAMT.053 Summary&nbsp;</li>
  <li>MT 940</li>
</ul>
<p>Intraday statements:</p>
<ul>
  <li>MT 942</li>
  <li>CAMT.052</li>
</ul>`

export const auditReports = `<p><strong>Navigation</strong>: Reports / Reporting and statements/ User activity audit reports</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/4/user_activity_audit.png'/></p>
<p><strong>Overview:</strong></p>
<p>This page enables you to see a summary of all actions taken by users during their session from log on to log off. The table shows you when the actions took place, the user responsible, the tracking ID and the accounts involved.&nbsp;</p>
<p><strong>Report Types:</strong>&nbsp;</p>
<p><strong>System Activity Report </strong>is a report that is generated for all activities in Lloyds Bank Gem Connect and can be filtered by the user. You can report on specific users / activity types and other options.</p>
<p><strong>On behalf of Report is</strong> a report of sessions where a colleague has logged on behalf of a user to view the pages as though they were the user. &nbsp;This is a read only section.</p>
<p><strong>Profile Permissions Report </strong>is a report that lists user profiles and their associated permissions and entitlements.</p>
<p><strong>Profile history</strong> is a summary of changes to user role profiles</p>
<p><strong>Step 1: </strong></p>
<p>You have the ability to create one off reports, or to set up parameters for a reoccurring report which is then accessible using the drop-down menus. You may also edit these saved reports, though only the user who has created the report is entitled to do so.</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/4/2.png'/></p>
<p><strong>Step 2: </strong></p>
<p>To create a new report, click on the name of the report, for example, “System activity”.  Select the relevant parameters within the report and then click on “Generate report” to run the report.&nbsp;</p>
<p>If you click on  “Save report criteria”, a pop up is displayed so you can add a name and a description for the saved report.  Saved reports are displayed in the User activity audit reports home screen and you can run the saved report by selecting the saved report and clicking on “Go”.  You can also edit or delete saved reports.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/8/4/3.png'/></p>`


// WEBPACK FOOTER //
// ./src/components/content/reports.ts